import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth/auth.service';
import { LogoService } from '@app/core/services/logo/logo.service';
import { SelectProviderDataService } from '@app/login/data/select-provider-data/select-provider-data.service';
import { UiButtonComponent } from '@app/shared/elements/ui-button/ui-button.component';
import { SidenavBarStoreService } from '@app/sidenav-bar/data/sidenav-bar-store/sidenav-bar-store.service';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'sliqpay-provider-config-error',
  imports: [UiButtonComponent],
  templateUrl: './provider-config-error.component.html',
  styleUrl: './provider-config-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderConfigErrorComponent {
  private readonly logoService = inject(LogoService);
  private router = inject(Router);
  private sidenavBarStoreService = inject(SidenavBarStoreService);
  private selectProviderDataService = inject(SelectProviderDataService);
  authService = inject(AuthService);

  readonly logoPath = this.logoService.getLogoFilePath('payon-light');

  retrying = signal(false);
  retryFailed = signal(false);

  constructor() {
    this.sidenavBarStoreService.setIsOpen(false);
  }

  onRetry(): void {
    const providerId = sessionStorage.getItem('provider');

    if (!providerId) {
      this.router.navigateByUrl('/login');
      return;
    }

    this.retrying.set(true);
    this.retryFailed.set(false);

    this.selectProviderDataService
      .setProvider$(providerId)
      .pipe(
        take(1),
        finalize(() => this.retrying.set(false))
      )
      .subscribe({
        next: () => this.router.navigateByUrl(this.getRedirectUrl()),
        error: () => this.retryFailed.set(true)
      });
  }

  private getRedirectUrl(): string {
    const stored = sessionStorage.getItem('provider_config_redirect');
    sessionStorage.removeItem('provider_config_redirect');

    const isValid =
      !!stored &&
      stored !== 'undefined' &&
      stored !== 'null' &&
      !stored.startsWith('/provider-config-error');

    return isValid ? stored : '/';
  }
}
